import Swal from 'sweetalert2';

export const validarForm = (datoObjeto, requiredFields, requiredFieldsText, requiredFieldsObs = []) => {
  for (let i = 0; i < requiredFields.length; i++) {
    const field = requiredFields[i];
    if (!datoObjeto[field]) {
      // Crear el texto del mensaje de error
      let mensajeError = `El elemento ${requiredFieldsText[i]} no puede ser nulo.`;
      
      // Añadir la observación si está presente en el arreglo de observaciones
      if (requiredFieldsObs[i]) {
        mensajeError += `\n${requiredFieldsObs[i]}`;
      }

      // Mostrar la alerta usando SweetAlert2
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: mensajeError,
        confirmButtonText: 'Aceptar',
      });

      return 0;
    }
  }
  return 1;
};